
  import { css } from 'lit';
  export const styles = css`:host{--base-circle-color: var(--ig-circular-bar-base-circle-color, var(--ig-gray-300));--ig-theme-variant: dark}`;
  